import type { FetchParams, PaginatedResponse } from "@nuxt/app";
import HttpFactory from "~/repository/factory";
import { ENDPOINTS } from "~/repository/endpoints";
import { normalizeEmailInput } from "~/utils/email";
import type {
  CreateUserSubscriptionInput,
  SubscriptionResponse,
  GrantFreeMonthsInput,
  GrantFreeMonthsResponse,
} from "~/types/admin/payment";

class AdminPaymentSubscriptionsModule extends HttpFactory {
  async getSubscriptions(
    fetchParams: FetchParams,
  ): Promise<PaginatedResponse<SubscriptionResponse>> {
    return await this.get<PaginatedResponse<SubscriptionResponse>>(
      `${ENDPOINTS.ADMIN.PAYMENT.SUBSCRIPTIONS}`,
      fetchParams,
    );
  }

  async getSubscription(id: string): Promise<SubscriptionResponse> {
    return await this.get<SubscriptionResponse>(
      `${ENDPOINTS.ADMIN.PAYMENT.SUBSCRIPTIONS}${id}/`,
    );
  }

  async grantSubscription(
    data: CreateUserSubscriptionInput,
  ): Promise<SubscriptionResponse> {
    const normalizedData = {
      ...data,
      user_email: normalizeEmailInput(data.user_email),
    };

    return await this.post<SubscriptionResponse>(
      `${ENDPOINTS.ADMIN.PAYMENT.GRANT_SUBSCRIPTION}`,
      normalizedData,
    );
  }

  async updateSubscription(
    id: string,
    data: any,
  ): Promise<SubscriptionResponse> {
    return await this.patch<SubscriptionResponse>(
      `${ENDPOINTS.ADMIN.PAYMENT.SUBSCRIPTIONS}${id}/`,
      data,
    );
  }

  async grantFreeMonths(
    data: GrantFreeMonthsInput,
  ): Promise<GrantFreeMonthsResponse> {
    const normalizedData = {
      ...data,
      user_email: normalizeEmailInput(data.user_email),
    };

    return await this.post<GrantFreeMonthsResponse>(
      `${ENDPOINTS.ADMIN.PAYMENT.GRANT_FREE_MONTHS}`,
      normalizedData,
    );
  }
}

export { AdminPaymentSubscriptionsModule };
